import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppRegistration24Px = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	enableBackground: "new 0 0 24 24",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
		fill: "none",
		height: 24,
		width: 24
	}) }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			height: 4,
			width: 4,
			x: 10,
			y: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 4,
			width: 4,
			x: 4,
			y: 16
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 4,
			width: 4,
			x: 4,
			y: 10
		}),
		/* @__PURE__ */ _jsx("rect", {
			height: 4,
			width: 4,
			x: 4,
			y: 4
		}),
		/* @__PURE__ */ _jsx("polygon", { points: "14,12.42 14,10 10,10 10,14 12.42,14" }),
		/* @__PURE__ */ _jsx("path", { d: "M20.88,11.29l-1.17-1.17c-0.16-0.16-0.42-0.16-0.58,0L18.25,11L20,12.75l0.88-0.88C21.04,11.71,21.04,11.45,20.88,11.29z" }),
		/* @__PURE__ */ _jsx("polygon", { points: "11,18.25 11,20 12.75,20 19.42,13.33 17.67,11.58" }),
		/* @__PURE__ */ _jsx("rect", {
			height: 4,
			width: 4,
			x: 16,
			y: 4
		})
	] }) })]
});
const ForwardRef = forwardRef(SvgAppRegistration24Px);
export { ForwardRef as ReactComponent };
